module.exports = __webpack_public_path__ + "static/media/private_filled.c2661566.svg";